import React from "react"

import { useAppDispatch, useAppSelector } from "../../../../hooks"
import { GlobalState } from "../../../../store"
import StickyFooter from "../../../stickyFooter/StickyFooter"
import { clickStateTransitionButtonThunk } from "./thunks"
import { IButtonData } from "../../../stickyFooter"

interface OwnProps {
    itemId: number
}
const PanelFooter: React.FC<OwnProps> = ({ itemId }: OwnProps) => {
    const dispatch = useAppDispatch()
    const [buttons, setButtons] = React.useState<IButtonData[]>([])
    const state = useAppSelector(
        (state: GlobalState) => state.itemDetail.actions,
    )
    const isLoading = useAppSelector(
        (state: GlobalState) => state.itemDetail.panelFooter.isLoading,
    )

    React.useEffect(() => {
        if (!state.buttons) {
            return
        }
        setButtons(
            state.buttons.map((button) => {
                return {
                    id: `${button.Id}`,
                    label: button.FlowLabel,
                    onClick: (): void => {
                        clickStateTransitionButton(button.Id)
                    },
                    style: {
                        isPrimaryColor: ["Primary", "Hidden"].includes(
                            button.Type,
                        ),
                        isFilled: button.Type !== "Dismissive",
                    },
                }
            }),
        )
    }, [state.buttons])

    // if there are no buttons then we don't show the footer
    if (!state.buttons) {
        return <></>
    }

    const clickStateTransitionButton = (buttonId: number): void => {
        dispatch(clickStateTransitionButtonThunk({ buttonId, itemId }))
    }

    return (
        <div id="resourceFooter">
            <StickyFooter
                buttons={buttons}
                isLoading={isLoading}
                footerClass="tw-p-4 bg-default"
            />
        </div>
    )
}
export default PanelFooter
